module.exports = __webpack_public_path__ + "static/media/portfolio.1eedef40.png";